import { render } from "./OilChangeReminders.vue?vue&type=template&id=41fb2af0"
import script from "./OilChangeReminders.vue?vue&type=script&lang=js"
export * from "./OilChangeReminders.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/RACINGBIKE/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__